import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../commponents/layout/adminLayout";
import DeliveryOrderBasicInformation from "../../commponents/deliveryOrder/detail/DeliveryOrderBasicInformation";
import DeliveryOrderItemList from "../../commponents/deliveryOrder/detail/DeliveryOrderItemList";
import { getDeliveryOrderById } from "../../api/deliveryOrderApi";
import { showError } from "../../utils/ alert";

interface DeliveryOrderDetailData {
  id: number;
  delivery_order_no: string;
  bill_to: string;
  address: string;
  phone: string;
  po_number: string;
  customer_id: string;
  delivery_date: string;
  due_date: string;
  checked_by: string;
  approved_by: string;
  received_by: string;
  status: string;
  createdAt: string;
  items: {
    description: string;
    qty: number;
    unit: string;
    remark: string;
  }[];
}

export default function DeliveryOrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [deliveryOrder, setDeliveryOrder] = useState<DeliveryOrderDetailData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        setLoading(true);
        const response = await getDeliveryOrderById(Number(id));
        setDeliveryOrder(response.data.data ?? response.data);
      } catch (error) {
   
        showError("Failed to load delivery order detail.");
        navigate("/delivery_order");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchDetail();
  }, [id]);

  if (loading || !deliveryOrder) {
    return (
      <AdminLayout>
        <div className="rounded-3xl bg-white p-6 text-center text-gray-400">Loading...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="rounded-3xl bg-white p-6">
          <h2 className="mb-4 text-lg font-semibold">Detail Delivery Order</h2>

          <DeliveryOrderBasicInformation
            deliveryOrder={{
              bill_to: deliveryOrder.bill_to,
              address: deliveryOrder.address,
              phone: deliveryOrder.phone,
              delivery_order_no: deliveryOrder.delivery_order_no,
              delivery_date: deliveryOrder.delivery_date,
              po_number: deliveryOrder.po_number,
              customer_id: deliveryOrder.customer_id,
              due_date: deliveryOrder.due_date,
              createdAt: deliveryOrder.createdAt,
            }}
            onEdit={() => navigate(`/delivery_order/edit/${deliveryOrder.id}`)}
          />
        </div>

        <div className="rounded-3xl bg-white p-6">
          <DeliveryOrderItemList
            items={deliveryOrder.items}
            checkedBy={deliveryOrder.checked_by}
            approvedBy={deliveryOrder.approved_by}
            receivedBy={deliveryOrder.received_by}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
